
const variants = {
  blink: 'animate-blink',
  scaleUp: 'animate-scale-up',
  moveUp: 'animate-move-up',
};
const sizes = {
  small: 'w-1 h-1',
  medium: 'w-2 h-2',
  large: 'w-3 h-3',
};

export default function Loader({
  tag = 'div',
  size = 'medium',
  variant = 'animate-blink',
}) {
  let Component = tag;
  return (
    <Component className={`spinner-loader flex items-center gap-2`}>
      <p>Loading</p>
      <span className={`bg-current animation-delay-100 rounded-full ${sizes[size]}`} />
      <span className={`animation-delay-250 bg-current rounded-full ${sizes[size]}`} />
      <span className={`animation-delay-400 bg-current rounded-full ${sizes[size]}`} />
    </Component>
  );
}
